<template>
	<article>
		<div class="divcontxt">
			<p>
				视频呼叫:{{this.$store.state.callinfo.roomtel}}
			</p>
			<p style="color: red">
				<b>{{ initstate }}</b>
			</p>
			<p id="calltimer"></p>
		</div>
		<div class="divhead" id="videos">
			<video id="remoteVideo" ref="remoteVideo" style="object-fit: fill" muted="true" preload="auto" autoplay="autoplay" x-webkit-airplay="allow" playsinline="true" webkit-playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portraint" ></video>
			<div class="arc" id="loading"></div>
			<canvas id="canvas"></canvas>
		</div>
		<div class="divcontrol">
			<div></div>
			<div class="divctrl">

				<div class="wpbutton" @click="hangup()">
					<img class="imgbt" src="../assets/hangup.png" />
				</div>


			</div>
		</div>
	</article>
</template>


<script>
import imga_1 from "../assets/ic_video_photo.png";
import imgb_1 from "../assets/ic_video_record.png";
import imgc_1 from "../assets/ic_video_stop.png";
import imgc_2 from "../assets/ic_video_stop_land.png";
import imgd_1 from "../assets/ic_video_unlock.png";
import imgd_2 from "../assets/ic_video_unlock_land.png";

const axios = require("axios");

export default {
	name: "HelloWorld",
	props: {
		msg: String,
	},

	data() {
		return {
			imgsrcscan: imga_1,
			imgsrcrecord: imgb_1,
			imgsrcspeek: imgc_2,
			imgsrcaudio: imgd_1,
			IsLocalDataChannel: true,
			isAndroid: false,
			isIos: false,
			isChrome: false,
			isWeixin: false,
			websock: null,
			showVideo: true,
			connected: false,
			connecting: false,
			videoplaying: false,
			socketTask: false,
			startRecive: false,
			StartCalled: false,
			CheckedgetUserMedia: false,
			IsWebSocketCreateed: false,
			IsWebSocketConnecting: false,
			IsWebSocketOpened: false,
			IsLocalAudioTrack: false,
			IsLocalVideoTrack: false,
			IsSystemAudioDeviceOK: false,
			IsFailCreate: false,
			recorded: false,
			speak: false,
			mute: false,
			myPeerConnection: null,
			myDataChannel: null,
			stream: null,
			remoteMediaStream: null,
			mediaRecorder: null,
			remoteVideo: null,
			heartCheck: null,
			messagecallback: null,
			RTCPeerConnectionCreated: false,
			peerid: "",
			meid: "",
			device_id: "",
			calltime: null,
			sessionId: "",
			wsurl: "",
			url: "",
			mymsg: false,
			roomId: "",
			IsReconnect: false,
			timeout: 2000,
			timedelay: 0,
			serverTimeoutObj: null,
			canAddIceCandidate: false,
			IceCandidate: new Array(),
			connectmode: "live",
			connectsource: "MainStream",
			configuration: {
				iceServers: [{
					urls: ["stun:webrtc.qq-kan.com:3478?transport=udp"],
				}, ],
			},
		};
	},
	created() {
		this.calltime = this.getQueryString("time");

		var serno = this.getQueryString("topeer");
		if (serno == null) {
			alert('目标错误');
			return;
		} else {
			this.peerid = serno;
		}
		this.sessionId = this.newGuid();

		var selfpeerid = this.getQueryString("mypeer");
		if (selfpeerid != null) {
			this.meid = selfpeerid;
		} else {
			alert('参数错误');
			return;
		}
		var device_id = this.getQueryString("device_id");
		if (device_id == null) {
			this.device_id = this.peerid;
		} else {
			this.device_id = device_id;
			if (this.$store.state.deviceId != '')
				this.device_id = this.$store.state.deviceId;
		}

		if (this.checktimesign()) {
			this.initWebSocket();
			this.NewgetUserMedia({
						video: this.$store.state.ability == 1 ? true : false,
						audio: true,
					},
					this.streamHandler,
					this.errorHandler
			);
			this.timerstart();
		}
	},
	mounted() {
		var Videos = document.getElementById("videos");
		var canvas = document.getElementById("canvas");
		var loading = document.getElementById("loading");
		canvas.style.display = "none";
		document.title = "WebRTC-设备端";

		var doorname = this.getQueryString("doorname");
		if (doorname != null) {
			// doorname = decodeURI(this.getQueryVariable("doorname"));
			document.title = doorname;
		}

		var u = window.navigator.userAgent;
		if (u != null) {
			this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //ios终端
			this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			this.isChrome = u.indexOf("Chrome") !== -1; //Chrome 浏览器
			this.isWeixin = u.indexOf("micromessenger") != -1; //微信浏览器
		}
		if (this.isIos || this.isAndroid) {
			Videos.style.width = "100%";
			// Videos.style.height =
			// 	Math.floor((document.documentElement.clientWidth * 9) / 16) + "px";

			loading.style.left =
					Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
			loading.style.top =
					Math.floor((document.documentElement.clientWidth * 9) / 16 / 2 - 25) +
					"px";
		} else {
			Videos.style.width = "100%";
			var temheight = Math.floor(
					(document.documentElement.clientWidth * 9) / 16
			);
			if (temheight > document.documentElement.clientHeight - 60) {
				// Videos.style.height =
				// 	Math.floor(document.documentElement.clientHeight - 60) + "px";
				loading.style.left =
						Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
				// loading.style.top = Math.floor(Videos.style.height / 2 - 25) + "px";
			} else {
				// Videos.style.height =
				// 	Math.floor((document.documentElement.clientWidth * 9) / 16) + "px";
				loading.style.left =
						Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
				// loading.style.top =
				// 	Math.floor((document.documentElement.clientWidth * 9) / 16 / 2 - 25) +
				// 	"px";
			}
		}

		loading.style.top = '45vh';
		this.remoteVideo = document.getElementById("remoteVideo");
		if (this.remoteVideo != null) {
			this.remoteVideo.muted = true;

			this.remoteVideo.addEventListener("playing", this.OnVideoPlaying);
			this.remoteVideo.addEventListener("play", this.OnVideoPlay);
			this.remoteVideo.addEventListener(
					"loadedmetadata",
					this.OnVideoLoadedMetaData
			);
			this.remoteVideo.addEventListener("canplay", this.OnVideoCanPlay);
			this.remoteVideo.addEventListener("error", this.OnVideoError);
			this.remoteVideo.addEventListener("loadeddata", this.OnVideoLoadedData);

			if (this.isWeixin == true && this.isIos == false) {
				console.log("Your browser Weixin  no ios");
			} else if (this.isWeixin == true && this.isIos == true) {
				console.log("Your browser Weixin addEventListener WeixinJSBridgeReady");
				document.addEventListener(
						"WeixinJSBridgeReady",
						function() {
							var that = this;
							if (this.videoplaying == false) {
								this.videoplaying = true;
								var playPromise = this.remoteVideo.play();
								if (playPromise) {
									playPromise
											.then(() => {
												that.videoplaying = true;
												console.log("browser Weixin <video> play.");
											})
											.catch((e) => {
												that.videoplaying = false;
												console.log("<video> play error ", e.message);
											});
								}
							}
						},
						false
				);

			} else {
				if (this.isChrome == true && this.isIos == false) {
					console.log("Your browser isChrome  no ios");
				} else {
					console.log("Your browser isChrome   ios");
				}
			}
		}
		let _this = this; //赋值vue的this
		window.onresize = () => {
			_this.pageResize();
		};

		// console.log('mounted  -----remotevideo ',this.remoteVideo);
	},
	computed: {
		initstate() {
			return this.$store.state.statename;
		},
	},
	destroyed() {
		window.onresize = null;
		if (this.websock != null) {
			this.websock.close();

		}
		if (this.stream != null)
			this.hangup();

	},
	methods: {
		getQueryVariable(variable) {
			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split("=");
				if (pair[0] == variable) {
					return pair[1];
				}
			}
			return false;
		},

		hangup() {
			this.$store.state.login = false;
			this.$store.state.isclose = true;

			this.wpvideocall("call-hangup");

			this.sendDisconnect();
			this.handleLeave();
			this.timerreset()

			this.close();

			var param = {
				cmd: "handup", //openDoor,handup,accept,refuse
				selfId: this.meid,
				sessionId: this.sessionId,
				deviceId: this.device_id,
			};
			this.posemqttcmd(param, "/mqtt/callSync");

		},

		posemqttcmd(parame, axurl) {
			// console.log("posemqttcmd:", axurl, parame);
			if (this.myPeerConnection != null) {
				axios({
					method: "post",
					url: axurl,
					baseURL: this.$store.state.callinfo.remotemqtturl,
					headers: {
						"Access-Control-Allow-Origin": "*",
						"Content-Type": "application/x-www-form-urlencoded",
						token: this.$store.state.accesstoken,
					},

					data: parame,
					params: parame,
				})
						.then((res) => {
							console.log(axurl, res.data);
							if (res.data.retCode == 200) {
								this.calltime = null;
							}
						})
						.catch((error) => {
							console.log(error);
						});
			}
		},

		// 呼叫接通和挂断清0
		wpvideocall(dooption = "call-confirm") {
			var param = {
				peerid: this.$store.state.callinfo.meid,
				meid: this.$store.state.callinfo.peerid,
				deviceId: this.$store.state.deviceId,
				phone: this.$store.state.callinfo.phone,
				roomtel: this.$store.state.callinfo.roomtel
			};
			// console.log(param);
			axios({
				method: "post",
				url: dooption, //call-hangup
				baseURL: this.$store.state.callinfo.remoteurl,
				headers: {
					"Access-Control-Allow-Origin": "*",
					// 'Content-Type': "application/x-www-form-urlencoded",
					// token: this.$store.state.accesstoken,
				},

				data: param,
				params: param,
			})
					.then((res) => {
						console.log(dooption, param, res.data);
						if (res.data.retCode == 200) {
							if (dooption == "call-confirm") {
								var that = this;
								var calltimer = document.getElementById("calltimer");
								that.$store.state.statename = "呼叫中";
								var ti = that.$store.state.talkTime * 60;
								if (ti > 0) {
									var stptimer = setInterval(function() {
										ti--;

										if (that.$store.state.isclose) clearInterval(stptimer);
										else {
											if (ti <= 0) {
												clearInterval(stptimer);
												that.$store.state.statename = "呼叫失败";
												that.hangup();
											} else calltimer.innerHTML = ti + "秒后结束";
										}
									}, 1000);
								}

							}

						} else {
							alert(res.data.message);
							return;
						}
					})
					.catch((error) => {
						console.log(error);
					});
		},

		checktimesign() {
			var nowtime = new Date().valueOf();
			if (this.calltime == null || nowtime - +this.calltime > 45 * 1000) {
				return false;
			}
			return true;
		},


		setlocalspeak() {

			if (this.myPeerConnection != null) {
				this.speak = !this.speak;
				if (this.speak == true) {
					this.imgsrcspeek = imgc_1;
				} else {
					this.imgsrcspeek = imgc_2;
				}

				if (this.remoteVideo != null) {
					if (this. remoteVideo.muted == true){
						this. remoteVideo.muted = false;
					}
				}

				var that = this;
				this.myPeerConnection.getReceivers().forEach(function(receiver) {
					if (receiver.track != null && receiver.track.kind === "audio") {
						receiver.track.enabled = that.speak;
						console.log(
								"PeerConnection  setlocalspeak    -------------------------------------- ",
								receiver
						);
					}
				});
			}
		},
		setlocalaudio() {

			if (this.myPeerConnection != null) {
				this.mute = !this.mute;
				if (this.mute == true) {
					this.imgsrcaudio = imgd_2;
				} else {
					this.imgsrcaudio = imgd_1;
				}
				var that = this;
				this.myPeerConnection.getSenders().forEach(function(sender) {
					if (sender.track != null && sender.track.kind === "audio") {
						sender.track.enabled = that.mute;
						console.log(
								"PeerConnection  setlocalaudio    -------------------------------------- ",
								sender
						);
					}
				});
			}
		},

		pageResize() {
			var Videos = document.getElementById("videos");
			var loading = document.getElementById("loading");
			if (this.isIos || this.isAndroid) {
				Videos.style.width = "100%";
				// Videos.style.height =
				// 	Math.floor((document.documentElement.clientWidth * 9) / 16) + "px";

				loading.style.left =
						Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
				// loading.style.top =
				// 	Math.floor((document.documentElement.clientWidth * 9) / 16 / 2 - 25) +
				// 	"px";
			} else {
				Videos.style.width = "100%";
				var temheight = Math.floor(
						(document.documentElement.clientWidth * 9) / 16
				);
				if (temheight > document.documentElement.clientHeight - 60) {
					// Videos.style.height =
					// 	Math.floor(document.documentElement.clientHeight - 60) + "px";
					loading.style.left =
							Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
					loading.style.top = Math.floor(Videos.style.height / 2 - 25) + "px";
				} else {
					// Videos.style.height =
					// 	Math.floor((document.documentElement.clientWidth * 9) / 16) + "px";
					loading.style.left =
							Math.floor(document.documentElement.clientWidth / 2 - 25) + "px";
					loading.style.top =
							Math.floor(
									(document.documentElement.clientWidth * 9) / 16 / 2 - 25
							) + "px";
				}
			}
			loading.style.top = '45vh';
		},
		timerreset() {
			clearTimeout(this.timeoutObj);
			clearTimeout(this.serverTimeoutObj);
		},
		timerstart() {
			var that = this;
			this.serverTimeoutObj = setInterval(function() {
				that.timedelay++;
				if (that.websock && that.websock.readyState === 1) {
					if (that.IsReconnect == true) {
						console.log("reconnect  ------------------- ");
						if (that.RTCPeerConnectionCreated == true) {
							that.handleLeave();
						}
						that.StartCalled = false;
						that.sessionId = that.newGuid();
					} else {
						if (that.timedelay > 30) {
							that.timedelay = 0;
							that.sendToServer({
								eventName: "__ping",
								data: {
									sessionId: that.sessionId,
									sessionType: "IE",
									messageId: that.newGuid(),
									from: that.meid,
									to: that.peerid,
								},
							});
						}
					}
					that.timerreset();
					that.timerstart();
				} else {
					if (that.IsWebSocketConnecting == false) {
						if (that.websock != null) {
							that.websock.close();
							that.websock = null;
						}
						if (that.RTCPeerConnectionCreated == true) {
							that.handleLeave();
						}

						that.initWebSocket();
					} else {
						console.log("IsWebSocketConnecting  ------------------- ");
					}
				}
			}, this.timeout);
		},
		initWebSocket() {
			if (!this.$store.state.login || this.$store.state.callinfo.meid == "")
				return;

			if (this.IsWebSocketConnecting == true) {
				return;
			}
			var ishttps = "https:" == document.location.protocol ? true : false;
			this.IsWebSocketConnecting = true;
			var wsuri = "";

			var host = this.getQueryString("server");
			if (host == null || host == "") {
				// host = "box.wangpeiaiot.com";
				host = "box.chinahjz.cn"
			}

			if (ishttps) {
				wsuri = "wss://" + host + "/wsequipment/" + this.meid;
			} else {
				wsuri = "ws://" + host + "/wsequipment/" + this.meid;
			}

			if (this.websock != null) {
				this.websock.close();
				this.websock = null;
			}
			this.websock = new WebSocket(wsuri);

			this.websock.onmessage = this.websocketonmessage;
			this.websock.onopen = this.websocketonopen;
			this.websock.onerror = this.websocketonerror;
			this.websock.onclose = this.websocketclose;
		},
		websocketonopen() {
			var that = this;
			this.IsWebSocketOpened = true;
			console.log("initWebSocket --------open！");
			if (this.websock != null && this.websock.readyState === 1) {
				this.StartCalled = false;
			} else {
				setTimeout(() => {
					if (that.websock != null && that.websock.readyState === 1) {
						that.StartCalled = false;
						// this.Connect();
					}
				}, 100);

			}
		},
		websocketonerror(e) {
			//连接建立失败重连
			this.IsWebSocketOpened = false;
			this.IsWebSocketConnecting = false;
			this.websock = null;
			console.log("连接错误", e);
			//this.meid=this.newGuid();
			//this.initWebSocket();
		},
		websocketonmessage(e) {
			//数据接收
			const data = JSON.parse(e.data);
			console.log(
					"-->>>>>>>>>>>>websocket--- onmessage--:" + data.eventName
			);

			switch (data.eventName) {
				case "_call":
					this.handleCall(data.data);
					break;
				case "_create":
					this.handleCreate(data.data);
					break;
				case "_answer":
					this.$store.state.statename = "接通中……";
					// console.log("recv answer sdp :" + data.data.sdp);
					this.handleAnswner(data.data);
					break;
				case "_ice_candidate":
					this.handleCandidate(data.data);
					break;
				case "_session_disconnected":
				case "_disconnected":
					this.$store.state.statename = "挂机";

					this.hangup();
					break;
				case "_post_message":
					this.handlePostMessage(data.data);
					break;
				case "_connectinfo":
				case "_connectto":
					this.handleConnectInfo(data.data);
					break;
				case "_session_failed":
					this.handleSessionFailed(data.data);
					break;
				case "_ping":
					break;
				default:
					console.log("Got default message", data);
					break;
			}
		},
		websocketsend(Data) {
			if (this.websock != null && this.websock.readyState === 1) {
				this.websock.send(Data);
			}
		},
		websocketclose(e) {
			//关闭
			this.IsWebSocketOpened = false;
			this.IsWebSocketConnecting = false;
			this.websock = null;
			console.log("断开连接", e);
		},
		getQueryString(name) {
			switch (name) {
				case "server":
					return this.$store.state.callinfo.server;

				case "mypeer":
					return this.$store.state.callinfo.meid;

				case "topeer":
					return this.$store.state.callinfo.peerid;

				case "doorname":
					return this.$store.state.callinfo.doorname;

				case "device_id":
					return this.$store.state.deviceId;

				case "time":
					return new Date().valueOf();

				default:
					return "";
			}
		},
		NewgetUserMedia(constrains, success, error) {
			//访问用户媒体设备的兼容方法
			console.log("NewgetUserMedia----------------");

			if (
					window.navigator.mediaDevices &&
					window.navigator.mediaDevices.getUserMedia
			) {
				//最新标准API
				window.navigator.mediaDevices
						.getUserMedia(constrains)
						.then(success)
						.catch(error);
			} else if (window.navigator.webkitGetUserMedia) {
				//webkit内核浏览器
				window.navigator
						.webkitGetUserMedia(constrains)
						.then(success)
						.catch(error);
			} else if (window.navigator.mozGetUserMedia) {
				//Firefox浏览器
				window.navagator.mozGetUserMedia(constrains).then(success).catch(error);
			} else if (window.navigator.getUserMedia) {
				//旧版API
				window.navigator.getUserMedia(constrains).then(success).catch(error);
			} else if (window.navigator.msGetUserMedia) {
				window.navigator.msGetUserMedia(constrains).then(success).catch(error);
			} else {
				this.CheckedgetUserMedia = false;
				this.IsLocalAudioTrack = false;
				console.log("Your browser no getUserMedia function");
			}
		},
		Connect() {
			// 设备端连上即可，等待——call
			this.sendToServer({
				eventName: "__connectto",
				data: {
					sessionId: this.sessionId,
					sessionType: "IE",
					messageId: this.newGuid(),
					from: this.meid,
					to: this.peerid,
				},
			});
		},
		handleDisconnect(data) {
			if (data.sessionId == this.sessionId) {
				console.log("handleDisconnect ", JSON.stringify(data));
				if (this.RTCPeerConnectionCreated == true) {
					this.handleLeave();
				}
			}
		},
		sendToServer(message) {
			console.log("------>>>>>>>>>>websocket---send : ", message.eventName);

			this.websocketsend(JSON.stringify(message));

		},
		PostMessage(message, callback) {
			if (this.connected == true) {
				var messageid = this.newGuid();
				this.messagecallback = callback;
				this.sendToServer({
					eventName: "__post_message",
					data: {
						sessionId: this.sessionId,
						sessionType: "IE",
						messageId: messageid,
						to: this.peerid,
						from: this.meid,
						message: message,
					},
				});
			}
		},
		handlePostMessage(data) {

			if (this.messagecallback === undefined || this.messagecallback === null) {
				//console.log("handlePostMessage");
			} else {
				typeof this.messagecallback === "function" &&
				this.messagecallback(data.message);
				this.messagecallback = null;
			}

			if (data.message == "callon") {
				this.$store.state.statename = "通话中";
				this.mute = true;
				this.setlocalspeak();
			}
		},
		handleSessionFailed(data) {
			console.log("handleSessionFailed ", data);
			if (data.sessionId == this.sessionId) {
				if (this.RTCPeerConnectionCreated == true) {
					this.handleLeave();
					this.sendDisconnect();
				}
				this.sessionId = this.newGuid();
			}
		},
		handleCreate(data) {
			console.log("WebSocket _create", data);
			if (data.state === "online" || data.state === "sleep") {
				this.IsWebSocketCreateed = true;
				if (
						data.iceServers !== null ||
						data.iceServers !== undefined ||
						data.iceServers !== ""
				) {
					//console.log("WebSocket iceServers", data.iceServers);
					//服务器把ICE 服务的信息下发到js创建RTCPeerConnection使用
					//configuration = JSON.parse(data.iceServers);
					if (data.iceServers.constructor === Object) {
						console.log(
								" _create  iceServers ---object ---- ",
								JSON.stringify(data.iceServers)
						);
						this.configuration = JSON.parse(JSON.stringify(data.iceServers));
					} else {
						console.log(
								" _create  iceServers ---string ---- :",
								data.iceServers
						);
						this.configuration = JSON.parse(data.iceServers);
					}
				}
				if (this.CheckedgetUserMedia == true && this.StartCalled == false) {
					console.log("handleCreate  start call");
					this.Call();
				} else {
					console.log(
							"handleCreate  CheckedgetUserMedia =",
							this.CheckedgetUserMedia,
							" StartCalled=",
							this.StartCalled
					);
				}
			} else {
				console.log(" _create  offline  ", data.from);
			}
		},
		Call() {
			this.StartCalled = true;
		},
		handleConnectInfo(data) {
			console.log("Got ConnectInfo Message:", data.message);
			this.sendToServer({
				eventName: "__pong",
				data: {
					sessionId: this.sessionId,
					sessionType: "IE",
					messageId: this.newGuid(),
					from: this.meid,
					to: this.peerid,
				},
			});
		},
		handleLeave() {
			console.log("handleLeave  --------");
			var that = this;

			if (this.myDataChannel != null) {
				this.myDataChannel.close();
				this.myDataChannel.onopen = null;
				this.myDataChannel.onclose = null;
				this.myDataChannel.onmessage = null;
				this.myDataChannel.onerror = null;
				this.myDataChannel = null;
			}
			if (this.myPeerConnection != null) {
				console.log(
						"handleLeave  --------signalingState = ",
						this.myPeerConnection.signalingState
				);
				if (this.myPeerConnection.signalingState == "closed") {
					this.handleRelease();
				} else {
					this.myPeerConnection.getSenders().forEach((sender) => {
						// console.log("removeTrack  ", sender);
						that.myPeerConnection.removeTrack(sender);
					});
					this.myPeerConnection.close();

					setTimeout(() => {
						if (that.myPeerConnection != null) {
							if (that.myPeerConnection.signalingState == "closed") {
								that.handleRelease();
							}
						}
					}, 100);
				}
			}
			this.videoplaying = false;
			this.RTCPeerConnectionCreated = false;
			this.StartCalled = false;
			this.IceCandidate.splice(0, this.IceCandidate.length);

		},
		handleRelease() {
			console.log("handleRelease  ========");
			if (this.myPeerConnection != null) {
				this.myPeerConnection.onicecandidate = null;
				this.myPeerConnection.onaddstream = null;
				this.myPeerConnection.ontrack = null;
				this.myPeerConnection.onsignalingstatechange = null;
				this.myPeerConnection.onicegatheringstatechange = null;
				this.myPeerConnection = null;
			}
			if (this.IsFailCreate == false) {
				this.IsReconnect = true;
			}
			window.localStream = null;
			this.stream = null;
		},
		async handleAnswner(data) {
			var that = this;
			console.log("  setRemoteDescription --------");
			var nativeRTCSessionDescription =
					window.mozRTCSessionDescription || window.RTCSessionDescription;
			var SessionDescription = new nativeRTCSessionDescription({
				type: "answer",
				sdp: data.sdp
			});
			await this.myPeerConnection.setRemoteDescription(SessionDescription).then(function() {
						that.canAddIceCandidate = true;
						that.IceCandidate.forEach((obj) => {
							console.log(" add addIceCandidate --------------", obj.candidate);

							var candidate = new RTCIceCandidate({
								sdpMLineIndex: obj.sdpMLineIndex,
								candidate: obj.candidate,
							});
							that.myPeerConnection.addIceCandidate(candidate);
						});
						that.IceCandidate.splice(0, that.IceCandidate.length);
					},
					function(err) {
						console.log("  setRemoteDescription --------error:" + err);
					});

		},
		async handleOffer(data) {
			var that = this;
			this.IsReconnect = false;
			console.log("Offer --- ---- sdp  :\n", data.sdp);

			if (this.RTCPeerConnectionCreated == false) {
				this.initPeerConnection();
			}
			if (this.RTCPeerConnectionCreated == false) {
				console.log(
						"handleOffer Failed   RTCPeerConnectionCreated = ",
						this.RTCPeerConnectionCreated
				);
				this.sendDisconnect();
				this.IsReconnect = false;
				this.IsFailCreate = true;
			}

			await this.myPeerConnection
					.createAnswer()
					.then(function(answer) {
						that.myPeerConnection.setLocalDescription(answer);
						console.log("Answer sdp :\n" + answer.sdp);
						that.sendToServer({
							eventName: "__answer",
							data: {
								sessionId: that.sessionId,
								sessionType: "IE",
								messageId: that.newGuid(),
								from: that.meid,
								to: that.peerid,
								type: answer.type,
								sdp: answer.sdp,
							},
						});
					})
					.catch(function(error) {
						console.log(
								"Error when create  Answer-----------------------------",
								error.message
						);
						that.sendDisconnect();
						that.IsReconnect = true;
						this.IsFailCreate = true;
					});
		},

		async handleCall(data) {
			this.IsReconnect = false;
			var that = this;
			// console.log("handleCall --- ----", data);
			this.sessionId = data.sessionId;
			if (
					data.iceservers !== null ||
					data.iceservers !== undefined ||
					data.iceservers !== ""
			) {
				this.configuration = JSON.parse(data.iceservers);
			}

			if (this.RTCPeerConnectionCreated == false) {
				this.initPeerConnection();
			}
			if (this.RTCPeerConnectionCreated == false) {
				this.sendDisconnect();
				this.IsReconnect = false;
				this.IsFailCreate = true;
			} else {


				await this.myPeerConnection
						.createOffer()
						.then(function(offer) {
							that.myPeerConnection.setLocalDescription(offer).then(
									function() {
										that.sendToServer({
											eventName: "__offer",
											data: {
												sessionId: that.sessionId,
												sessionType: "IE",
												messageId: that.newGuid(),
												from: that.meid,
												to: that.peerid,
												type: offer.type,
												sdp: offer.sdp,
												mode: "live",
												source: "MainStream",
												datachannel: "true",
												audio: "sendrecv",
												video: "sendrecv",
												user: "admin",
												pwd: "123456",
												iceservers: data.iceServers,
											},
										});


									},
									function(err) {
										console.log("  setLocalDescription --------error " + err);
									});

						})
						.catch(function(error) {
							console.log(
									"Error when create  offer-----------------------------",
									error.message
							);
							that.sendDisconnect();
							that.IsReconnect = true;
							this.IsFailCreate = true;
						});


			}
		},

		sendDisconnect() {
			this.sendToServer({
				eventName: "__disconnected",
				data: {
					sessionId: this.sessionId,
					sessionType: "IE",
					messageId: this.newGuid(),
					from: this.meid,
					to: this.peerid,
				},
			});
		},
		async handleCandidate(data) {
			console.log("----handleCandidate-data：", data, data.candidate)

			var obj = {};
			try {
				obj = JSON.parse(data.candidate);
			}catch (e){
				console.error("JSON解析错误:",e);
			}

			// var obj= JSON.parse(data.candidate);

			if (
					this.myPeerConnection != null &&
					this.RTCPeerConnectionCreated == true &&
					this.canAddIceCandidate == true
			) {
				console.log("--handleCandidate  --- 1----   :", obj.candidate);
				var candidate = new RTCIceCandidate({
					sdpMLineIndex: obj.sdpMLineIndex,
					candidate: obj.candidate,
				});
				await this.myPeerConnection.addIceCandidate(candidate).then(
						function() {
							console.log(" IceCandidate  sucessed");
						},
						function(err) {
							console.log("add IceCandidate error:", +err);

						});
			} else {
				console.log("handleCandidate add to tmp IceCandidate", obj);
				this.IceCandidate.push(obj);
			}
		},
		initPeerConnection() {
			try {

				this.myPeerConnection = new RTCPeerConnection(this.configuration);
				if (this.myPeerConnection != null) {
					if ("addTrack" in this.myPeerConnection) {
						if (this.stream != null) {
							this.stream.getTracks().forEach((track) => {
								this.myPeerConnection.addTrack(track, this.stream);
								console.log("PeerConnection use addTrack type", track.kind);
								if (track.kind === "audio") {
									track.enabled = true;
								}
							});
						} else {
							console.log("PeerConnection  addTrack  stream is null");
						}
					} else {
						if (this.stream != null) {
							this.myPeerConnection.addStream(this.stream);
							this.stream.getTracks().forEach((track) => {
								console.log("PeerConnection use addStream type", track.kind);
								if (track.kind === "audio") {
									track.enabled = true;
								}
							});
						} else {
							console.log("PeerConnection  addStream is null");
						}
					}
					if ("ontrack" in this.myPeerConnection) {
						this.myPeerConnection.ontrack = this.handleRemoteTrackAdded;
					} else {
						this.myPeerConnection.onaddstream = this.handleRemoteStreamAdded;
					}
					this.myPeerConnection.onicecandidate = this.handleIceCandidate;
					this.myPeerConnection.oniceconnectionstatechange =
							this.handleIceConnectionStateChangeEvent;
					this.myPeerConnection.onicegatheringstatechange =
							this.handleIceGatheringStateChangeEvent;
					this.myPeerConnection.onsignalingstatechange =
							this.handleSignalingStateChangeEvent;
					//myPeerConnection.onnegotiationneeded = handleNegotiationNeededEvent;
					if (this.IsLocalDataChannel == true) {
						try {
							this.myDataChannel =
									this.myPeerConnection.createDataChannel("mydatachannel");
							if (this.myDataChannel) {
								this.myDataChannel.onopen = this.handleDataChannelOnOpen;
								this.myDataChannel.onclose = this.handleDataChannelOnClose;
								this.myDataChannel.onmessage = this.handleDataChannelOnMessage;
								this.myDataChannel.onerror = this.handleDataChannelOnError;
							}
						} catch (error) {
							console.log("data_channel_create_error  ");
						}
					}
					console.log("Sucessed to create PeerConnection");
					this.RTCPeerConnectionCreated = true;
				} else {
					console.log("Failed to create PeerConnection");
					this.RTCPeerConnectionCreated = false;
				}
			} catch (e) {
				console.log("Failed to create PeerConnection, exception: " + e.message);
				this.RTCPeerConnectionCreated = false;
				return;
			}
		},
		getObjectURL(stream) {
			var url = null;
			try {
				if (window.createObjectURL != undefined) {
					url = window.createObjectURL(stream);
					console.log("window createObjectURL", url);
				} else if (window.URL != undefined) {
					url = window.URL.createObjectURL(stream);
					console.log("window window.URLcreateObjectURL ", url);
				} else if (window.webkitURL != undefined) {
					url = window.webkitURL.createObjectURL(stream);
					console.log("window.webkitURL.createObjectURL ", url);
				}
			} catch (error) {
				url = null;
			}
			return url;
		},
		handleRemoteTrackAdded(e) {
			this.remoteMediaStream = e.streams[0];
			//console.log("handleRemoteTrackAdded",JSON.stringify(e));
			if (this.remoteVideo != null) {
				e.streams[0].getTracks().forEach((track) => {
					if (track.kind === "audio") {
						track.enabled = true;
					}
				});
				this.remoteVideo.srcObject = e.streams[0];
				if (this.IsSystemAudioDeviceOK == false) {
					this.remoteVideo.muted = false;
				}
			} else {
				console.log("handleRemoteTrackAdded  video view is null");
			}
		},
		handleRemoteStreamAdded(e) {
			this.remoteMediaStream = e.stream;
			if (this.remoteVideo != null) {
				if ("srcObject" in this.remoteVideo) {
					console.log(
							"handleRemoteStreamAdded attachStream srcObject stream id = ",
							e.stream.id
					);
					this.remoteVideo.srcObject = e.stream;
					e.stream.getTracks().forEach((track) => {
						console.log("handleRemoteTrackAdded  ", track);
						if (track.kind === "audio") {
							track.enabled = true;
						}
					});
				} else {
					var objUrl = this.getObjectURL(e.stream);
					console.log(
							"handleRemoteStreamAdded attachStream getObjectURL stream id = ",
							e.stream.id
					);
					this.remoteVideo.src = objUrl;
					e.stream.getTracks().forEach((track) => {
						console.log("handleRemoteTrackAdded  ", track);
						if (track.kind === "audio") {
							track.enabled = true;
						}
					});
				}
			}
		},
		handleIceCandidate(event) {
			if (event.candidate) {
				// console.log("onicecandidate: ------------------>>>>>>>>" + event.candidate.candidate);
				this.sendToServer({
					eventName: "__ice_candidate",
					data: {
						sessionId: this.sessionId,
						sessionType: "IE",
						messageId: this.newGuid(),
						to: this.peerid,
						from: this.meid,
						candidate: JSON.stringify({
							candidate: event.candidate.candidate,
							sdpMid: event.candidate.sdpMid,
							sdpMLineIndex: event.candidate.sdpMLineIndex,
						}),
					},
				});
			}

		},
		handleIceConnectionStateChangeEvent(event) {
			if (this.myPeerConnection == null) {
				return;
			}

			console.log("*** ICE connection state changed to " + this.myPeerConnection.iceConnectionState, event);
			if (event.target == this.myPeerConnection) {
				console.log(
						"*** ICE connection state changed to ",
						event.target.iceConnectionState
				);

				switch (this.myPeerConnection.iceConnectionState) {
					case "closed":
						this.handleRelease();
						break;
					case "failed":
					case "disconnected":
						if (this.RTCPeerConnectionCreated == true) {
							this.handleLeave();
							this.sendDisconnect();
						}
						break;
					case "connected":
						this.videoplay();
						break;
				}
			}
		},
		handleIceGatheringStateChangeEvent(event) {
			if (this.myPeerConnection == null) {
				return;
			}
			if (event.target == this.myPeerConnection) {
				console.log(
						"*** ICE gathering state changed to: " +
						event.target.iceGatheringState
				);
			}
		},
		handleSignalingStateChangeEvent(event) {
			if (this.myPeerConnection == null) {
				return;
			}
			if (event.target == this.myPeerConnection) {
				console.log(
						"*** WebRTC signaling state changed to: " +
						event.target.signalingState
				);
				switch (this.myPeerConnection.signalingState) {
					case "closed":
						this.handleLeave();
						break;
				}
			}
		},
		handleDataChannelOnOpen() {
			console.log("handleDataChannelOnOpen");
			if (this.myDataChannel) {
				this.myDataChannel.send(
						JSON.stringify({
							title: "siren",
							sequence: 0,
							payload: {
								alarm_audio: true,
							},
						})
				);
			}
		},
		handleDataChannelOnClose(event) {
			console.log("handleDataChannelOnClose ", event);
		},
		handleDataChannelOnMessage(message) {
			console.log("handleDataChannelOnMessage ", message);
			var json;
			json = JSON.parse(message.data);
			if (json.type === "__file") {
				console.log("handleDataChannelOnClose recive message data", json.data);
			} else if (json.type === "__msg") {
				console.log("handleDataChannelOnClose recive message data", json.data);
			} else {
				console.log("handleDataChannelOnClose recive message data", json.data);
			}
		},
		handleDataChannelOnError(err) {
			console.log("handleDataChannelOnError ", err);
		},
		close() {
			if (this.socketTask && this.socketTask.close) {
				this.socketTask.close();
			}
		},
		newGuid() {
			let s4 = function() {
				return ((65536 * (1 + Math.random())) | 0).toString(16).substring(1);
			};
			return (
					s4() +
					s4() +
					"-" +
					s4() +
					"-4" +
					s4().substr(0, 3) +
					"-" +
					s4() +
					"-" +
					s4() +
					s4() +
					s4()
			).toUpperCase();
		},
		streamHandler(mystream) {
			this.CheckedgetUserMedia = true;
			//window.localStream = mystream;
			this.stream = mystream;
			console.log("streamHandler  stream = ", this.stream);
			if ("getTracks" in mystream) {
				// console.log("streamHandler getTracks");
				if (mystream != null) {
					mystream.getTracks().forEach((track) => {
						// console.log("streamHandler getTracks ", track);

						if (track.kind === "audio") {
							this.wpvideocall("call-confirm");
							this.IsLocalAudioTrack = true;
						} else if (track.kind === "video") {
							if (this.$store.state.ability < 1) {
								track.stop(); // 关闭摄像头
							} else {
								this.IsLocalVideoTrack = true;
							}
						}

					});
				}
			}
			if (this.StartCalled == false && this.IsWebSocketCreateed == true) {
				//console.log("streamHandler  start call");

			}
		},
		errorHandler(error) {
			console.log("errorHandler", error);
			this.CheckedgetUserMedia = true;
			if (this.StartCalled == false && this.IsWebSocketCreateed == true) {
				//console.log("streamHandler  start call");

			}
		},
		videoplay() {
			var that = this;
			if (this.videoplaying == false) {
				this.videoplaying = true;
				var playPromise = this.remoteVideo.play();
				if (playPromise) {
					playPromise
							.then(() => {
								that.videoplaying = true;
								console.log("<video>  play");
							})
							.catch((e) => {
								that.videoplaying = false;
								console.log("<video> play error", e.message);
							});
				}
			}
		},
		OnVideoPlay() {
			console.log("<video> event OnVideoPlay------");
		},
		OnVideoLoadedMetaData() {
			console.log("<video> event OnVideoLoadedMetaData----------------");
			this.videoplay();
		},
		OnVideoCanPlay() {
			console.log(
					"<video>  OnVideoCanPlay-----videoWidth = " +
					this.remoteVideo.videoWidth
			);
			console.log(
					"<video>  OnVideoCanPlay-----videoHeight = " +
					this.remoteVideo.videoHeight
			);
			console.log(
					"<documentElement>  OnVideoCanPlay------clientWidth = " +
					document.documentElement.clientWidth
			);
			console.log(
					"<documentElement>  OnVideoCanPlay------clientHeight = " +
					document.documentElement.clientHeight
			);
			var loading = document.getElementById("loading");
			if (loading != null) loading.style.display = "none";

			var canvas = document.getElementById("canvas");
			if (canvas != null) {
				canvas.style.width = this.remoteVideo.videoWidth;
				canvas.style.height = this.remoteVideo.videoHeight;
			}


			var Videos = document.getElementById("videos");
			if (Videos != null) {
				Videos.style.width = "100%";
			}

			if (this.$store.state.ability < 1) {
				Videos.style.display = "none";
			}

			var temheight =
					(document.documentElement.clientWidth * this.remoteVideo.videoHeight) /
					this.remoteVideo.videoWidth;
			if (temheight > document.documentElement.clientHeight) {
				if (this.isIos) {
					//Videos.style.height= Math.floor(document.documentElement.clientWidth*this.remoteVideo.videoHeight/this.remoteVideo.videoWidth)+"px";
				} else {
					//Videos.style.height= Math.floor(document.documentElement.clientHeight)+"px";
				}
			} else {
				// Videos.style.height= Math.floor(document.documentElement.clientWidth*this.remoteVideo.videoHeight/this.remoteVideo.videoWidth)+"px";
			}
			if (Videos != null) {
				console.log("<video>----------------height " + Videos.style.height);
			}

			if (this.remoteVideo.muted == true) {
				if (this.isIos == false) {
					this.remoteVideo.muted = false;
				}
				console.log("<video>----------------muted = true");
			} else {
				console.log("<video>----------------muted = false");
			}
		},
		OnVideoError() {
			console.log("<video> event OnVideoError----------------");
		},
		OnVideoLoadedData() {
			console.log("<video> event OnVideoLoadedData----------------");
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
article {
	height: 100vh;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: space-around;
	align-items: center;
}

.divhead {
	width: 100vw;
	height: 100vw;

}

.divcontrol {
	width: 100%;
	background-color: #000000;
}

.divcontxt p {
	color: #fff;
}

.divctrl {
	width: 100%;
	/* Safari */
	-webkit-flex-direction: row;
	/* Safari 6.1+ */

	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: space-around;
	align-items: center;
}


.imgbutton {
	margin: 0px 5px 5px 0px;
	width: 50px;
	height: 50px;
}

.imgbutton1 {
	margin: 0px 5px 5px 0px;
	width: 45px;
	height: 45px;
}

.imgbt {
	width: 100%;
	height: 100%;
}

.wpbutton {
	margin: 5px 5px 5px 5px;
	width: 50px;
	height: 50px;
	text-align: center;
	color: #ccc;
}

.arc {
	--width: 100%;
	--height: 100%;
	position: absolute;
	margin: auto;
	left: calc(var(--width) / 2 - 25px);
	top: calc(var(--height) / 2 - 25px);
	width: 50px;
	height: 50px;
	border-radius: 50%;
	border-top: 2px solid #ffea29;
	border-left: 1px solid transparent;
	border-right: 1px solid transparent;
	animation: rt 2s infinite linear;
}

.arc::before {
	position: absolute;
	margin: auto;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 0;
	height: 0;
	width: 35px;
	height: 35px;
	border-radius: 50%;
	border-top: 2px solid #8d29ff;
	border-left: 1px solid transparent;
	border-right: 1px solid transparent;
	animation: rt 4s infinite linear reverse;
	content: "";
}

.arc::after {
	position: absolute;
	margin: auto;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 0;
	height: 0;
	width: 0;
	height: 0;
	border-radius: 50%;
	border-top: initial;
	border-left: initial;
	border-right: initial;
	animation: cw 1s infinite;
	content: "";
	background: snow;
}

@keyframes rt {
	100% {
		transform: rotate(360deg);
	}
}

@keyframes cw {
	0% {
		width: 0;
		height: 0;
	}

	75% {
		width: 20px;
		height: 20px;
	}

	100% {
		width: 0;
		height: 0;
	}
}

.scale {
	background: #ddd;
	width: 100%;
	height: 3px;
	position: relative;
	margin: 0px 0px 0px 0px;
}

.scale span {
	background: #aaa;
	width: 8px;
	height: 16px;
	position: absolute;
	left: -2px;
	top: -6px;
	cursor: pointer;
	border-radius: 3px;
}

.scale div {
	background: #66d9ef;
	position: absolute;
	height: 3px;
	width: 0;
	left: 0;
	bottom: 0;
}

video {
	margin: 0px 0px 0px 0px;
	font-size: 16px;
	color: #fff;
	background-color: #000000;
	object-fit: fill;
	width: 100%;
	height: 100%;
	muted: "true";
	preload: "auto";
	autoplay: "autoplay";
	x-webkit-airplay: "true";
	playsinline: "true";
	controls: "false";
	webkit-playsinline: "true";
	x5-video-player-type: "h5";
	x5-video-player-fullscreen: "true";
	x5-video-orientation: "portraint";
}
</style>
